const map = {
	"./Icon-UI.svg": 1073,
	"./Icon-activities.svg": 80016,
	"./Icon-afi.svg": 26071,
	"./Icon-catalogue.svg": 71402,
	"./Icon-clasifications.svg": 21137,
	"./Icon-customer-care.svg": 54855,
	"./Icon-firebase.svg": 82236,
	"./Icon-food&drinks.svg": 99570,
	"./Icon-hotels.svg": 85438,
	"./Icon-lock.svg": 24822,
	"./Icon-maps.svg": 97018,
	"./Icon-modules.svg": 17614,
	"./Icon-parques-tours.svg": 85960,
	"./Icon-promos.svg": 92379,
	"./Icon-rh.svg": 62541,
	"./Icon-roles.svg": 40818,
	"./Icon-services.svg": 98247,
	"./Icon-settings.svg": 66576,
	"./Icon-user.svg": 77878,
	"./Icon-users.svg": 6633,
	"./Icon-x-design.svg": 74600,
	"./Icon-xailing.svg": 16163,
	"./bus_1.svg": 63117,
	"./bus_2.svg": 14766,
	"./bus_3.svg": 43199,
	"./catalogues_1.svg": 80175,
	"./catalogues_2.svg": 77852,
	"./configuration_1.svg": 62949,
	"./ferrys_1.svg": 30826,
	"./home_1.svg": 88852,
	"./hotels_1.svg": 96116,
	"./hotels_2.svg": 83975,
	"./hotels_3.svg": 44438,
	"./icon-photos.svg": 63144,
	"./parks_1.svg": 64624,
	"./parks_2.svg": 21667,
	"./restaurants_1.svg": 37423,
	"./restaurants_2.svg": 58396,
	"./spa_1.svg": 52205
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94601;